import { useState } from "react";
import { fechaHora } from "@/lib/constants";
import { Copy, Check } from "lucide-react";

function renderMentions(texto, menciones) {
  const names = (menciones || []).map((m) => m.nombre).filter(Boolean).sort((a, b) => b.length - a.length);
  if (!names.length) return texto;
  const esc = names.map((n) => n.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"));
  const re = new RegExp("@(" + esc.join("|") + ")", "g");
  const parts = [];
  let last = 0;
  let match;
  let k = 0;
  while ((match = re.exec(texto)) !== null) {
    if (match.index > last) parts.push(texto.slice(last, match.index));
    parts.push(
      <span key={`m-${k++}`} className="font-semibold text-violet-600">{match[0]}</span>
    );
    last = match.index + match[0].length;
  }
  if (last < texto.length) parts.push(texto.slice(last));
  return parts;
}

export default function CommentItem({ c, testidPrefix = "comentario" }) {
  const [copiado, setCopiado] = useState(false);

  const copiar = async () => {
    try {
      await navigator.clipboard.writeText(c.texto || "");
    } catch {
      const ta = document.createElement("textarea");
      ta.value = c.texto || "";
      document.body.appendChild(ta);
      ta.select();
      try { document.execCommand("copy"); } catch (err) { console.error("No se pudo copiar el comentario:", err); }
      document.body.removeChild(ta);
    }
    setCopiado(true);
    setTimeout(() => setCopiado(false), 1500);
  };

  return (
    <div className="flex gap-3 group" data-testid={`${testidPrefix}-${c.id}`}>
      <div className="h-8 w-8 rounded-full bg-slate-100 flex items-center justify-center text-xs font-semibold text-slate-600 shrink-0">
        {c.autor?.[0]?.toUpperCase() || "?"}
      </div>
      <div className="min-w-0 flex-1">
        <div className="text-xs text-slate-400 flex items-center gap-2">
          <span>
            <span className="font-semibold text-slate-700">{c.autor}</span> · {fechaHora(c.fecha)}
          </span>
          <button
            onClick={copiar}
            data-testid={`${testidPrefix}-copiar-${c.id}`}
            title="Copiar comentario"
            className="opacity-0 group-hover:opacity-100 focus:opacity-100 transition-opacity inline-flex items-center gap-1 text-slate-400 hover:text-slate-700"
          >
            {copiado ? (
              <><Check size={12} className="text-emerald-600" /> Copiado</>
            ) : (
              <><Copy size={12} /> Copiar</>
            )}
          </button>
        </div>
        <p className="text-sm text-slate-700 whitespace-pre-wrap">{renderMentions(c.texto, c.menciones)}</p>
      </div>
    </div>
  );
}
